import { Table } from 'antd';
import { ColumnsType } from 'antd/lib/table';
import React from 'react';

interface VehiclePayments {
  id: number;
  vehicle: string;
  buyer: string;
  amount: string;
  status: string;
}

const SoldVehiclePayments: React.FC = () => {
  const columns: ColumnsType<VehiclePayments> = [
    {
      title: 'Vehicle',
      dataIndex: 'vehicle',
      key: 'vehicle',
    },
    {
      title: 'Buyer',
      dataIndex: 'buyer',
      key: 'buyer',
    },
    {
      title: 'Sold Price',
      dataIndex: 'amount',
      key: 'amount',
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
    },
  ];

  const buyers: readonly any[] | undefined = [];

  return <Table dataSource={buyers} columns={columns} rowKey='id' size='small' />;
};

export default SoldVehiclePayments;
